import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ_ITEMS = [
  {
    q: "L'essai est-il vraiment gratuit ?",
    a: "Oui, 14 jours sans carte bancaire. Aucun paiement avant la fin de l'essai.",
  },
  {
    q: 'Puis-je changer de plan à tout moment ?',
    a: "Oui, vous pouvez upgrader ou downgrader depuis votre espace abonnement. Les changements prennent effet immédiatement.",
  },
  {
    q: 'Que se passe-t-il si je résilie ?',
    a: "Vous conservez l'accès jusqu'à la fin de la période payée. Vos données restent disponibles 30 jours pour export.",
  },
];

export function PricingFAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-bold font-display text-center">Questions fréquentes</h2>
      {FAQ_ITEMS.map((item, i) => (
        <div key={i} className="border border-border rounded-xl overflow-hidden">
          <button
            onClick={() => setOpen(open === i ? null : i)}
            className="w-full flex items-center justify-between px-4 py-3.5 text-left text-sm font-medium hover:bg-secondary/50 transition-colors"
          >
            <span>{item.q}</span>
            {open === i
              ? <ChevronUp size={16} className="shrink-0 text-muted-foreground" />
              : <ChevronDown size={16} className="shrink-0 text-muted-foreground" />}
          </button>
          <AnimatePresence>
            {open === i && (
              <motion.div
                initial={{ height: 0 }} animate={{ height: 'auto' }} exit={{ height: 0 }}
                className="overflow-hidden"
              >
                <p className="px-4 pb-4 text-sm text-muted-foreground leading-relaxed">{item.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}
